// Custom components
import {
  UseFormRegister,
  FieldErrors,
  Path,
  RegisterOptions,
} from "react-hook-form";

interface InputFieldProps<T> extends React.ComponentPropsWithoutRef<"input"> {
  id: Path<T>;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  type?: string;
  minLength?: number;
  maxLength?: number;
  defaultValue?: string;
  step?: string;
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  validationSchema: RegisterOptions<T>;
}

const InputField = <T,>(props: InputFieldProps<T>) => {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    minLength,
    maxLength,
    defaultValue,
    step,
    register,
    errors,
    validationSchema,
    ...rest
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {" "}
        {label}
        {validationSchema.required && (
          <span className="text-red-500 dark:text-red-400">*</span>
        )}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        step={step}
        minLength={minLength}
        maxLength={maxLength}
        defaultValue={defaultValue}
        min={type === "date" ? new Date().toISOString().split("T")[0] : ""}
        placeholder={placeholder}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none transition-all duration-300 ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error" || errors.root || errors[id]
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
        onWheel={(e) => e.currentTarget.blur()}
        {...register(id, validationSchema)}
        {...rest}
      />
      {(errors.root || errors[id]) && (
        <span className="ml-2 mt-1 text-sm text-red-500 dark:text-red-400">
          {errors?.root?.message?.toString() || (errors[id]?.message as string)}
        </span>
      )}
    </div>
  );
};

export default InputField;
